export const ChatAction = Object.freeze({
	ChangeDeadline: 'changeDeadline',
	CompleteTask: 'completeTask',
	OpenResult: 'openResult',
	ShowCheckList: 'showCheckList',
	ShowCheckListItems: 'showCheckListItems',
	OpenGroup: 'openGroup',
	OpenTimeTracking: 'openTimeTracking',
});
